export const STAGES = [
  "Order Received",
  "Content Downloaded",
  "Editors Assigned",
  "Editing In Progress",
  "Quality Check",
  "Final Review",
  "Delivered",
];

// Lucide icon *names* per service (imported in Order.jsx via a lookup)
export const SERVICE_ICON = {
  premium_short: "Rocket",
  volume_short: "Layers",
  long_form: "Film",
  thumbnails: "Image",
  carousels: "GalleryHorizontal",
  strategy: "Compass",
};

export const SOURCE_TYPES = [
  "Direct Link",
  "YouTube",
  "Google Drive",
  "Dropbox",
  "OneDrive",
  "Vimeo",
  "Twitch",
  "Kick",
  "Loom",
  "Other Public Link",
  "Private Link",
];

export const FAQS = [
  {
    q: "Who edits my videos?",
    a: "Real people. Every piece of content is edited by a professional human editor from our vetted studio team. We match you with editors experienced in your niche.",
  },
  {
    q: "How fast is turnaround?",
    a: "Standard delivery is 3-5 business days. Yearly subscribers receive priority editing and faster turnaround.",
  },
  {
    q: "Which platforms is the content optimized for?",
    a: "TikTok, Instagram Reels, YouTube Shorts, X, Facebook Reels, LinkedIn—vertical short-form is our specialty.",
  },
  {
    q: "Can I request revisions?",
    a: "Yes. Each piece of content includes one round of revision at no extra cost. Additional rounds are available.",
  },
  {
    q: "How do subscriptions work?",
    a: "Choose Monthly, 3-Month, or Yearly cadences. You get lower per-piece pricing, priority editing, and consistent output every cycle.",
  },
  {
    q: "Is my content secure?",
    a: "We use encrypted storage and every editor signs an NDA. Your raw footage is deleted 30 days after final delivery unless requested otherwise.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ava Marchetti",
    role: "Founder, Marchetti Media",
    avatar: "https://i.pravatar.cc/120?img=47",
    quote:
      "Bliencer's editors treat every hook like it matters. Retention curves on our shorts jumped 41% in the first month.",
  },
  {
    name: "Devin Okoye",
    role: "Podcast Host, The Long Game",
    avatar: "https://i.pravatar.cc/120?img=12",
    quote:
      "I've tried the AI clippers. Nothing compares to actual editors who understand narrative pacing.",
  },
  {
    name: "Priya Vale",
    role: "Creator, 1.2M subs",
    avatar: "https://i.pravatar.cc/120?img=45",
    quote:
      "Same-week delivery, no notes. The Hormozi-style pack pulled 8M views across three platforms.",
  },
  {
    name: "Kellan Wu",
    role: "Head of Content, Tender & Co.",
    avatar: "https://i.pravatar.cc/120?img=15",
    quote:
      "Feels like an in-house team without the overhead. Their QC catches things I would've missed.",
  },
  {
    name: "Sana Delacroix",
    role: "Executive Coach",
    avatar: "https://i.pravatar.cc/120?img=32",
    quote:
      "Booked $84k in new discovery calls from clips edited by Bliencer in the first quarter alone.",
  },
  {
    name: "Marcus Reed",
    role: "Creator, Gaming Vertical",
    avatar: "https://i.pravatar.cc/120?img=68",
    quote:
      "Their gaming edits actually understand pacing and meme timing. Uploads went from weekly to daily.",
  },
];
